// Configuration for image URLs
// Uses relative URLs (/api/products/images/...) which go through the nginx proxy
// to the API Gateway, which streams binary data with proper Content-Type headers.
// This ensures compatibility with Docker, Android Emulator, and Flutter Image.network().
// Using relative URLs avoids CORS issues and works in both dev and production.

/**
 * Convert a relative image URL (e.g., /uploads/products/xxx.png)
 * to a relative URL pointing to the API Gateway's image streaming endpoint
 * via the nginx proxy (/api/ → http://api-gateway:3000).
 *
 * /uploads/products/xxx.png → /api/products/images/xxx.png
 * /uploads/offers/xxx.png    → /api/offers/images/xxx.png
 */
export const getImageUrl = (imageUrl: string | null | undefined): string => {
  if (!imageUrl) return '';
  
  // If it's already an absolute URL (http://, https://, data:), return as-is
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://') || imageUrl.startsWith('data:')) {
    return imageUrl;
  }
  
  // Map /uploads/products/xxx.png → /api/products/images/xxx.png
  // Map /uploads/offers/xxx.png    → /api/offers/images/xxx.png
  // Map /uploads/categories/xxx.png → /api/categories/images/xxx.png
  if (imageUrl.startsWith('/uploads/products/')) {
    const filename = imageUrl.replace('/uploads/products/', '');
    return `/api/products/images/${filename}`;
  }
  if (imageUrl.startsWith('/uploads/offers/')) {
    const filename = imageUrl.replace('/uploads/offers/', '');
    return `/api/offers/images/${filename}`;
  }
  if (imageUrl.startsWith('/uploads/categories/')) {
    const filename = imageUrl.replace('/uploads/categories/', '');
    return `/api/categories/images/${filename}`;
  }
  if (imageUrl.startsWith('/uploads/merchants/')) {
    const filename = imageUrl.replace('/uploads/merchants/', '');
    return `/api/merchants/images/${filename}`;
  }
  
  // Fallback: return as-is (should not happen with valid image URLs)
  return imageUrl;
};
